<template>
  <div class="layout-form" :class="{ 'with-title': !!title, readonly: readonly }">
    <div v-if="title" class="form-title" :class="{ collapsed: collapsed }">
      <div class="title">{{ title }}</div>
      <div class="spacer"></div>
      <a v-if="!noToggle" class="toggle" @click="collapsed = !collapsed">
        <i class="fal" :class="collapsed ? 'fa-chevron-double-down' : 'fa-chevron-double-up'"></i
        >{{ collapsed ? '展开' : '隐藏' }}
      </a>
    </div>
    <div v-show="!collapsed">
      <slot></slot>
    </div>
  </div>
</template>

<script type="text/babel">
'use strict'

export default {
  props: ['title', 'noToggle', 'defaultCollapsed', 'readonly'],
  data() {
    return {
      collapsed: !!this.title && !this.noToggle && !!this.defaultCollapsed
    }
  },
  computed: {}
}
</script>



// WEBPACK FOOTER //
// client/app/vue-components/common/bootstrapvue-console/FormBlock.vue